import { z } from 'zod';

const changelogHighlightSchema = z.object({
  icon: z.string().min(1),
  title: z.string().min(1),
  description: z.string().min(1),
});

export const createChangelogEntrySchema = z.object({
  version: z.string().regex(/^\d+\.\d+\.\d+$/, 'Version must be in semver format (e.g. 1.0.0)'),
  release_date: z.string().min(1),
  title_fr: z.string().min(1),
  title_en: z.string().min(1),
  highlights_fr: z.array(changelogHighlightSchema).default([]),
  highlights_en: z.array(changelogHighlightSchema).default([]),
  improvements_fr: z.array(z.string()).default([]),
  improvements_en: z.array(z.string()).default([]),
  fixes_fr: z.array(z.string()).default([]),
  fixes_en: z.array(z.string()).default([]),
  is_published: z.boolean().default(false),
});

export type CreateChangelogEntryPayload = z.infer<typeof createChangelogEntrySchema>;
